module.exports = __webpack_public_path__ + "static/w-d0d5eafe1f4094949b3f99ae7b1427c0.jpg";